"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const supportsLocalStorage_1 = __importDefault(require("../utils/supportsLocalStorage"));
const experiments_1 = require("../constants/experiments");
exports.default = (experimentGoal, experimentName) => {
    if (!supportsLocalStorage_1.default())
        return null;
    try {
        const item = window.localStorage.getItem(`${experiments_1.PREFIX}::${experimentGoal}::${experimentName}`);
        return item && JSON.parse(item);
    }
    catch (err) {
        return null;
    }
};
//# sourceMappingURL=getExperiment.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/experiments/getExperiment.js
// module id = cE2V
// module chunks = 69